import { render, staticRenderFns } from "./commonAside.vue?vue&type=template&id=72c11123"
import script from "./commonAside.vue?vue&type=script&lang=js"
export * from "./commonAside.vue?vue&type=script&lang=js"
import style0 from "./commonAside.vue?vue&type=style&index=0&id=72c11123&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports